import { useEffect, useState } from "react";

export const CURRENCIES = ["USD", "EUR", "GBP", "INR", "AUD", "CAD", "CHF", "CNY", "DKK", "HKD", "JPY", "NOK", "NZD", "SEK", "SGD", "THB", "ZAR"];

const REGION_CURRENCY = {
  AT: "EUR", AU: "AUD", BE: "EUR", CA: "CAD", CH: "CHF", CN: "CNY",
  DE: "EUR", DK: "DKK", ES: "EUR", FI: "EUR", FR: "EUR", GB: "GBP",
  GR: "EUR", HK: "HKD", IE: "EUR", IN: "INR", IT: "EUR", JP: "JPY",
  LU: "EUR", NL: "EUR", NO: "NOK", NZ: "NZD", PT: "EUR", SE: "SEK",
  SG: "SGD", TH: "THB", US: "USD", ZA: "ZAR",
};

const detectCurrency = () => {
  if (typeof navigator === "undefined") return "USD";
  const locale = navigator.languages?.[0] || navigator.language || "en-US";
  let region = locale.split("-")[1]?.toUpperCase();
  try {
    region = new Intl.Locale(locale).maximize().region || region;
  } catch {
    // The language tag fallback above covers older browsers.
  }
  return REGION_CURRENCY[region] || "USD";
};

export const useCurrency = () => {
  const [currency, setCurrency] = useState("USD");
  const [rates, setRates] = useState({ USD: 1 });
  const [ratesReady, setRatesReady] = useState(false);

  useEffect(() => {
    fetch("https://api.frankfurter.dev/v2/rates?base=USD")
      .then((response) => response.ok ? response.json() : Promise.reject(new Error("Rates unavailable")))
      .then((rows) => {
        const nextRates = rows.reduce((all, row) => ({ ...all, [row.quote]: row.rate }), { USD: 1 });
        const preferredCurrency = detectCurrency();
        setRates(nextRates);
        setCurrency(nextRates[preferredCurrency] ? preferredCurrency : "USD");
        setRatesReady(true);
      })
      .catch(() => {
        setCurrency("USD");
        setRatesReady(false);
      });
  }, []);

  const format = (usd) => new Intl.NumberFormat(undefined, {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  }).format(usd * (rates[currency] || 1));

  return { currency, setCurrency, ratesReady, format };
};
